<template>
    <img
        :src="templateImage"
        class="template-image"
        alt="template"
    />
</template>

<script>
    export default {
        props: {
            template: {
                type: Object,
                default: () => ({}),
            }
        },
        computed: {
            templateImage() {
                return this.template.DashboardTemplatePicture
                    ? this.template.DashboardTemplatePicture
                    : '/img/IconDashboardTemplate.png'
            }
        }
    }
</script>

<style lang="scss" scoped>
.template-image {
    aspect-ratio: 16/9;
    @apply w-full object-cover;
}
</style>
